import React from 'react';
import './RedditButton.css';

// The Clomp community on Reddit
export const REDDIT_URL = 'https://www.reddit.com/r/Clompio/';

// A labelled button, for use within a page's content, with Reddit's alien mark in its orange
export function RedditButton() {
    return (
        <a className="reddit-btn" href={REDDIT_URL} target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="12" fill="#ff4500" />
                <path fill="white" d="M19.6 12.1a1.75 1.75 0 0 0-2.97-1.25c-1.2-.82-2.83-1.35-4.64-1.42l.79-3.72 2.58.55a1.25 1.25 0 1 0 .13-.61l-2.88-.61a.31.31 0 0 0-.37.24l-.88 4.15c-1.84.05-3.5.58-4.71 1.42a1.75 1.75 0 1 0-1.93 2.86c-.03.18-.04.36-.04.54 0 2.77 3.22 5.02 7.2 5.02s7.2-2.25 7.2-5.02c0-.18-.01-.36-.04-.53a1.75 1.75 0 0 0 .96-1.62zM7.6 13.35a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zm6.97 3.3c-.85.85-2.48.92-2.96.92s-2.11-.07-2.96-.92a.32.32 0 0 1 .46-.46c.54.54 1.68.73 2.5.73s1.96-.19 2.5-.73a.32.32 0 0 1 .46.46zm-.23-2.05a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" />
            </svg>
            Join on Reddit
        </a>
    );
}
